import Vue from 'vue';

// 注册一个全局指令
Vue.directive('titletip', {
    inserted(el, binding) {
        el.setAttribute('title', binding.value);
    },
    update(el, binding) {
        el.setAttribute('title', binding.value);
    }
});
